'use strict';

// TODO; semver-major: remove

module.exports = require('call-bind');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/callBind.js
// module id = 474
// module chunks = 0